export const mergeOmitNull = (a, b) => (b === null ? a : undefined);
